// import { useEffect, useState } from 'react';
import { /* useLocation, */ useNavigate, useSearchParams } from 'react-router';
import Heading from '@/components/Heading/Heading';
import Button from '@/components/ui/button';
import PageShell from '@/components/PageShell';
import { blobStorage } from '@/utils/helpers/storage.helpers';
import useAppStore, { useResetStore } from '@/store';

function SettingsPage() {
  const [searchParams] = useSearchParams();
  // const { state } = useLocation();
  const navigate = useNavigate();
  // const [isSafari, setIsSafari] = useState(false);

  // useEffect(() => {
  //   const isSafari =
  //     typeof navigator !== 'undefined' &&
  //     /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

  //   setIsSafari(isSafari);
  // }, []);

  const devMode = searchParams.get('devmode');

  // Hooks must run before any early return.
  const resetStore = useResetStore();

  if (devMode !== 'true') {
    navigate('/about-us', { state: { message: '' }, replace: true });
    return null;
  }

  // const { message = 'Your gift has been sent!' } = state || {};

  const resetApp = () => {
    resetStore();
    blobStorage.clear();
    // `navigate(0)` reloads, so any confirmation here would be destroyed
    // before it could be read. The emptied store is the confirmation.
    navigate(0);
  };

  const leavePage = () => {
    navigate('/about-us', { state: { message: '' }, replace: true });
    window.location.reload();
  };

  return (
    <>
      {/* <title>
        {message || 'Settings'} | Mia Wealth - Gift your child a brighter
        financial future
      </title> */}
      <PageShell variant='single' className='about-us-page'>
        <Heading classes='text-2xl' align='center'>
          Settings
        </Heading>

        <p className='mb-4'>Click here to reset the app:</p>
        <Button type='button' onClick={resetApp} className='mb-4'>
          Reset App
        </Button>

        <div>
          <Heading level={2} classes='text-2xl' align='center'>
            Current State
          </Heading>
          <pre className='bg-white p-4 rounded-lg overflow-auto mt-4 max-h-[400px] text-left'>
            <code>{JSON.stringify(useAppStore.getState(), null, 2)}</code>
          </pre>
        </div>
        <div>
          <Button type='button' onClick={leavePage} className='mt-4'>
            Leave Settings
          </Button>
        </div>
      </PageShell>
    </>
  );
}

export default SettingsPage;
